import React, { Component } from "react";
import PropTypes from "prop-types";

class Tabs extends Component {
  state = {
    activeTab: 0,
  };

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.activeView) {
      return {
        activeTab: nextProps.tabItems.findIndex(
          x => x.alias === nextProps.activeView,
        ),
      };
    }
    return null;
  }

  render() {
    const { className, onTabClick, tabItems } = this.props;
    const { activeTab } = this.state;
    if (tabItems) {
      return (
        <div className="tabs-wrapper">
          {tabItems.map((item, index) => (
            <div
              data-test="tabs-documentordealtable-button"
              key={item.name}
              className={`tabs-item ${className} ${item.alias} ${
                activeTab === index ? "is-active" : ""
              }`}
              onClick={() => {
                this.setState({ activeTab: index });
                onTabClick(item);
              }}
              onKeyPress={() => onTabClick(item)}
              role="button"
              tabIndex="0">
              {item.icon} {item.name} {item.count ? `(${item.value})` : ""}
            </div>
          ))}
        </div>
      );
    }
    return null;
  }
}

Tabs.defaultProps = {
  className: PropTypes.string,
};

Tabs.propTypes = {
  className: PropTypes.string,
  onTabClick: PropTypes.func.isRequired,
  tabItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/commonComponents/Tabs/Tabs.js